module.exports = __webpack_public_path__ + "static/media/icon-tablets.67769304.svg";